import type { Theme, Components } from '@mui/material/styles';
import type { ListItemTextProps } from '@mui/material/ListItemText';

// ----------------------------------------------------------------------

const MuiListItemIcon: Components<Theme>['MuiListItemIcon'] = {
  // ▼▼▼▼▼▼▼▼ 🎨 STYLE ▼▼▼▼▼▼▼▼
  styleOverrides: {
    root: ({ theme }) => ({
      color: 'inherit',
      minWidth: 'auto',
      marginRight: theme.spacing(2),
    }),
  },
};

const MuiListItemAvatar: Components<Theme>['MuiListItemAvatar'] = {
  // ▼▼▼▼▼▼▼▼ 🎨 STYLE ▼▼▼▼▼▼▼▼
  styleOverrides: {
    root: ({ theme }) => ({
      minWidth: 'auto',
      marginRight: theme.spacing(2),
    }),
  },
};

const MuiListItemText: Components<Theme>['MuiListItemText'] = {
  // ▼▼▼▼▼▼▼▼ ⚙️ PROPS ▼▼▼▼▼▼▼▼
  defaultProps: {
    // Secondary is typed as Typography<'p'> in v9, but Minimal renders it as a
    // span to keep an inline layout — cast through unknown to satisfy the check.
    slotProps: {
      primary: { sx: { typography: 'subtitle2' } },
      secondary: { component: 'span' },
    } as ListItemTextProps['slotProps'],
  },
  // ▼▼▼▼▼▼▼▼ 🎨 STYLE ▼▼▼▼▼▼▼▼
  styleOverrides: {
    root: { margin: 0 },
    multiline: { margin: 0 },
  },
};

/* **********************************************************************
 * 🚀 Export
 * ********************************************************************* */
export const list: Components<Theme> = {
  MuiListItemIcon,
  MuiListItemText,
  MuiListItemAvatar,
};
